import { useEffect } from "react";

interface JsonLdProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    script.setAttribute("data-readdy-jsonld", "true");
    document.head.appendChild(script);
    return () => {
      const el = document.head.querySelector('script[data-readdy-jsonld="true"]');
      if (el) el.remove();
    };
  }, [data]);

  return null;
}